"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import AddNewPost from "@/app/components/CMS/add-new";
import { isLoggedIn } from "@/app/funcs/api";
import SectionGridList from "../SectionGridList";

export default function JobsList() {
  const [showAddNew, setShowAddNew] = useState(false);
  const [userLoggedIn, setUserLoggedIn] = useState(false);

  useEffect(() => {
    setUserLoggedIn(!!isLoggedIn());
  }, []);

  const handleAddNewClick = () => {
    if (!userLoggedIn) {
      toast.error("لابد ان تسجل الدخول لتتمكن من المشاركة");
      return;
    }
    setShowAddNew((v) => !v);
  };

  /** "تقدم للوظيفة" button rendered below each card's author row */
  const cardFooter = (item) => {
    const applyLink = item?.acf?.apply_link || item?.link || null;
    if (!applyLink) return null;

    return (
      <div
        className="mt-2 position-relative"
        style={{ zIndex: 2 }}
        onClick={(e) => e.stopPropagation()}
        onPointerDown={(e) => e.stopPropagation()}
      >
        <a
          href={applyLink}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-sm btn-dark w-100"
        >
          <i className="bi bi-send me-1" aria-hidden />
          تقدم للوظيفة
        </a>
      </div>
    );
  };

  return (
    <SectionGridList
      postType="job"
      pageTitle="الوظائف"
      description="اكتشف أحدث فرص العمل في مجالات تصميم تجربة المستخدم وواجهة المستخدم."
      hrefBase="/sections/jobs"
      searchPlaceholder="ابحث عن وظيفة..."
      emptyMessage="لا يوجد وظائف متاحة حالياً."
      fallbackIcon="bi-briefcase"
      imageMaxHeight="200px"
      imageFit="cover"
      cardFooter={cardFooter}
      titleActions={
        <button
          type="button"
          className="btn btn-dark"
          onClick={handleAddNewClick}
          title="إضافة وظيفة جديدة"
        >
          <i className="bi bi-plus-lg" aria-hidden /> أضف وظيفة 😊
        </button>
      }
      belowTitle={
        showAddNew ? (
          <AddNewPost
            postTypes={["job"]}
            onCancelEdit={() => setShowAddNew(false)}
          />
        ) : null
      }
    />
  );
}
